import trackingSuite from './adobe-tracking';
import { setTrackingProductCode } from './tracking-helper';

export default function trackPage() {
    const $pageView = $('.page-content-visible');
    const trackingConfig = window.espnTrackingConfig;
    if (trackingConfig && !trackingConfig.suppressPageViewTracking) {
        window.espnTrackingConfig = window.espnTrackingConfig || {};
        const pageTrackingData = $pageView.data('tracking');
        const decodedTrackingValues = JSON.parse(decodeURIComponent(pageTrackingData));
        window.espnTrackingConfig.delayedValues = { ...decodedTrackingValues } || {};

        if (!window.espnTrackingConfig.trackingDisabled) {
            setTrackingProductCode($pageView);
            trackingSuite.trackPageView();
        }
    }
}
